import type {
  ArchivedDevice,
  Device,
  DeviceBrand,
  DeviceCreateInput,
  DeviceDetail,
  DeviceListItem,
  DeviceModel,
  DeviceType,
  DeviceUpdateInput,
} from "../domain";
import type {
  ArchivedDeviceListItemDto,
  DeviceBrandDto,
  DeviceCreateDto,
  DeviceDetailDto,
  DeviceDto,
  DeviceListItemDto,
  DeviceModelDto,
  DeviceTypeDto,
  DeviceUpdateDto,
} from "./deviceDtos";

export function deviceTypeFromDto(dto: DeviceTypeDto): DeviceType {
  return {
    id: dto.id,
    nameEn: dto.nameEn,
    nameAr: dto.nameAr,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
}

export function deviceBrandFromDto(dto: DeviceBrandDto): DeviceBrand {
  return {
    id: dto.id,
    nameEn: dto.nameEn,
    nameAr: dto.nameAr,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
}

export function deviceModelFromDto(dto: DeviceModelDto): DeviceModel {
  return {
    id: dto.id,
    nameEn: dto.nameEn,
    nameAr: dto.nameAr,
    deviceBrandId: dto.deviceBrandId,
    deviceTypeId: dto.deviceTypeId,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
}

export function deviceCreateToDto(input: DeviceCreateInput): DeviceCreateDto {
  return {
    ...(input.accountId !== undefined ? { accountId: input.accountId } : {}),
    ...(input.deviceModelId !== undefined
      ? { deviceModelId: input.deviceModelId }
      : {}),
    imei: input.imei.trim(),
    simNumber: input.simNumber.trim(),
    serialNumber: input.serialNumber.trim(),
    assetId: input.assetId,
    expiryDate: input.expiryDate,
    ...(input.notes && input.notes.trim().length > 0
      ? { notes: input.notes.trim() }
      : {}),
  };
}

export function deviceUpdateToDto(input: DeviceUpdateInput): DeviceUpdateDto {
  return {
    ...(input.assetId !== undefined ? { assetId: input.assetId } : {}),
    ...(input.notes !== undefined
      ? { notes: input.notes === null ? null : input.notes.trim() }
      : {}),
  };
}

export function deviceFromDto(dto: DeviceDto): Device {
  return {
    id: dto.id,
    code: dto.code,
    imei: dto.imei,
    simNumber: dto.simNumber,
    serialNumber: dto.serialNumber,
    notes: dto.notes,
    status: dto.status,
    installationDate: dto.installationDate,
    expiryDate: dto.expiryDate,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    account: dto.account,
    asset: dto.asset,
    deviceType: dto.deviceType,
    deviceBrand: dto.deviceBrand,
    deviceModel: dto.deviceModel,
  };
}

export function deviceDetailFromDto(dto: DeviceDetailDto): DeviceDetail {
  return {
    id: dto.id,
    code: dto.code,
    imei: dto.imei,
    simNumber: dto.simNumber,
    serialNumber: dto.serialNumber,
    notes: dto.notes,
    status: dto.status,
    installationDate: dto.installationDate,
    expiryDate: dto.expiryDate,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    account: dto.account,
    asset: dto.asset,
    deviceType: dto.deviceType,
    deviceBrand: dto.deviceBrand,
    deviceModel: dto.deviceModel,
    sensorMappings: dto.sensorMappings,
  };
}

export function deviceListItemFromDto(dto: DeviceListItemDto): DeviceListItem {
  return {
    id: dto.id,
    code: dto.code,
    imei: dto.imei,
    status: dto.status,
    expiryDate: dto.expiryDate,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    account: dto.account,
    asset: dto.asset,
    deviceType: dto.deviceType,
    deviceBrand: dto.deviceBrand,
    deviceModel: dto.deviceModel,
  };
}

export function archivedDeviceFromDto(
  dto: ArchivedDeviceListItemDto,
): ArchivedDevice {
  return {
    id: dto.id,
    code: dto.code,
    imei: dto.imei,
    account: dto.account,
    asset: dto.asset,
    deviceBrand: dto.deviceBrand,
    deviceModel: dto.deviceModel,
    archivedAt: dto.archivedAt,
  };
}
